import React from 'react';
import { Card, CardBody, Modal, ModalBody } from 'reactstrap';

const SendResetLinkConfirm = ({
  setConfirmModal,
  userEmail,
  handleSendResetLink,
}) => {
  return (
    <Modal
      isOpen={true}
      toggle={() => setConfirmModal(false)}
      centered
      className="modal-dialog-centered"
    >
      <ModalBody className="p-4">
        <Card className="border-0 shadow-sm">
          <CardBody className="p-4 text-center">
            <div className="mb-4">
              <i
                className="bx bx-mail-send text-primary"
                style={{ fontSize: '3rem' }}
              ></i>
              <h4 className="mt-3 mb-2">Send Password Reset Link</h4>
              <p className="text-muted">
                Are you sure you want to send a password reset link to
                <br />
                <strong>{userEmail}</strong>?
              </p>
            </div>

            <div className="d-flex justify-content-center gap-3">
              <button
                onClick={() => setConfirmModal(false)}
                className="btn btn-outline-secondary px-4"
                style={{ minWidth: '100px' }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  handleSendResetLink();
                  setConfirmModal(false);
                }}
                className="btn btn-primary px-4"
                style={{ minWidth: '100px' }}
              >
                Send
              </button>
            </div>
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
  );
};

export default SendResetLinkConfirm;
